module.exports = __webpack_public_path__ + "static/Carly_Daniel10-5ead0ae3e13dcaaef22d7636c08c52c5.jpg";